import Icon from "./icon.component";
import {
  smSize, mdSize, lgSize, xxlSize, xsSize,
} from "./icon.constants";

export {
  Icon, smSize, mdSize, lgSize, xxlSize, xsSize,
};
